import { Controller } from "@hotwired/stimulus";

// Keeps the hidden seconds field in step with the amount and unit beside it. Only that field carries a
// name, so the form still submits plain seconds.
const UNIT_SECONDS = { seconds: 1, minutes: 60, hours: 3600, days: 86400 };

export default class extends Controller {
  static targets = ["seconds", "amount", "unit"];

  sync() {
    const amount = this.amountTarget.value.trim();
    if (amount === "") {
      this.secondsTarget.value = "";
      return;
    }
    // Text that isn't a number would land in the hidden field as NaN and save as 0, so hold the last
    // good seconds instead and let the amount box show what was typed.
    const seconds = Number(amount) * (UNIT_SECONDS[this.unitTarget.value] ?? 1);
    if (Number.isFinite(seconds)) {
      this.secondsTarget.value = String(Math.round(seconds));
    }
  }
}
